import React from 'react';
import { useTranslation } from 'react-i18next';
import { QualityCheckResult } from './qualityChecks';
import MaterialIcon from '../shared/MaterialIcon';

interface Props {
  result: QualityCheckResult;
}

const ROW_ICON: Record<string, string> = {
  pass: 'check_circle',
  fail: 'cancel',
  na: 'remove',
  rec_missing: 'radio_button_unchecked',
};

const Row: React.FC<{ label: string; state: 'pass' | 'fail' | 'na' | 'rec_missing' }> = ({
  label,
  state,
}) => {
  const color =
    state === 'pass' ? 'text-green-600' : state === 'fail' ? 'text-red-600' : 'text-gray-500';
  return (
    <li className="flex items-center gap-2 text-sm">
      <MaterialIcon name={ROW_ICON[state]} className={`${color} text-base`} />
      <span className={state === 'fail' ? 'text-red-700' : ''}>{label}</span>
    </li>
  );
};

const QualityChecklist: React.FC<Props> = ({ result }) => {
  const { t } = useTranslation();
  return (
    <div className="p-4 border rounded-lg bg-gray-50">
      <div className="text-sm font-semibold mb-2">{t('article.quality_title')}</div>
      <ul className="space-y-1">
        <Row label={t('article.quality_numbered_list')} state={result.numberedList ? 'pass' : 'fail'} />
        <Row label={t('article.quality_bullet_list')} state={result.bulletList ? 'pass' : 'fail'} />
        <Row
          label={
            result.quotes === 'not_applicable'
              ? `${t('article.quality_quotes')} (${t('article.quality_quotes_na')})`
              : t('article.quality_quotes')
          }
          state={result.quotes === 'pass' ? 'pass' : result.quotes === 'fail' ? 'fail' : 'na'}
        />
        <Row label={t('article.quality_variance')} state={result.paragraphVariance ? 'pass' : 'fail'} />
        <Row label={t('article.quality_table')} state={result.table ? 'pass' : 'rec_missing'} />
        <Row label={t('article.quality_images')} state={result.imageSuggestions ? 'pass' : 'rec_missing'} />
      </ul>
    </div>
  );
};

export default QualityChecklist;
